/**
 * Generates a color heat based on column index
 * @param {number} index - Column index (0-based)
 * @param {number} totalColumns - Total number of columns (optional, defaults to 5)
 * @returns {string} CSS color representing heat level
 */
export default (index, totalColumns = 5) => {
  // Normalize index to 0-1 range
  const normalizedIndex = Math.min(index / (totalColumns - 1), 1);

  // Define color stops for heat gradient (cool to hot)
  const colorStops = [
    { pos: 0.0, r: 59, g: 130, b: 246 }, // Cool blue (#3B82F6)
    { pos: 0.25, r: 34, g: 197, b: 94 }, // Cool green (#22C55E)
    { pos: 0.5, r: 251, g: 191, b: 36 }, // Warm yellow (#FBBF24)
    { pos: 0.75, r: 249, g: 115, b: 22 }, // Hot orange (#F97316)
    { pos: 1.0, r: 239, g: 68, b: 68 }, // Hot red (#EF4444)
  ];

  // Find the two color stops to interpolate between
  let lowerStop = colorStops[0];
  let upperStop = colorStops[colorStops.length - 1];

  for (let i = 0; i < colorStops.length - 1; i++) {
    if (
      normalizedIndex >= colorStops[i].pos &&
      normalizedIndex <= colorStops[i + 1].pos
    ) {
      lowerStop = colorStops[i];
      upperStop = colorStops[i + 1];
      break;
    }
  }

  // Calculate interpolation factor
  const range = upperStop.pos - lowerStop.pos;
  const factor = range === 0 ? 0 : (normalizedIndex - lowerStop.pos) / range;

  // Interpolate RGB values
  const r = Math.round(lowerStop.r + (upperStop.r - lowerStop.r) * factor);
  const g = Math.round(lowerStop.g + (upperStop.g - lowerStop.g) * factor);
  const b = Math.round(lowerStop.b + (upperStop.b - lowerStop.b) * factor);

  return `rgb(${r}, ${g}, ${b})`;
};
